module.exports = __webpack_public_path__ + "img/img24.7d511dad.jpg";